import styled from 'styled-components';

import { theme } from '@attain-sre/attain-design-system';

export const Wrapper = styled.div`
  align-items: center;
  background: ${theme.colors.backgroundPrimary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  width: 100vw;
`;

export const Logo = styled.img`
  display: block;
  width: 150px;
  height: 150px;
`;

export const Message = styled.p`
  ${theme.typography.bodyLG};
  max-width: 516px;
  margin-top: 20px;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
